import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import AppLayout from "@/components/layout/AppLayout";
import DashboardPage from "@/pages/DashboardPage";
import EmployeeListPage from "@/pages/employees/EmployeeListPage";
import AssetListPage from "@/pages/assets/AssetListPage";
import SiteListPage from "@/pages/sites/SiteListPage";
import ComingSoonPage from "@/pages/ComingSoonPage";
import EquipmentPage from "@/pages/equipment/EquipmentPage";
import OperationsPage from "@/pages/operations/OperationsPage";
import TransportLogPage from "@/pages/transport/TransportLogPage";
import ReportsPage from "@/pages/reports/ReportsPage";
import DailyLogCheckPage from "@/pages/dailyLogCheck/DailyLogCheckPage";
import PaymentDeskPage from "@/pages/paymentDesk/PaymentDeskPage";
import VendorMasterPage from "@/pages/vendorMaster/VendorMasterPage";
import BankMasterPage from "@/pages/configurations/BankMasterPage";
import { ServiceTypesPage, GradesPage, PartCodesPage } from "@/pages/serviceTracker/ServiceMasterPage";
import ServiceTrackerPage from "@/pages/serviceTracker/ServiceTrackerPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="employees" element={<EmployeeListPage />} />
        <Route path="assets" element={<AssetListPage />} />
        <Route path="sites" element={<SiteListPage />} />
        <Route path="equipment" element={<EquipmentPage />} />
        <Route path="operations" element={<OperationsPage />} />
        <Route path="transport-log" element={<TransportLogPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="vendor-master" element={<VendorMasterPage />} />
        <Route path="configurations/bank-master" element={<BankMasterPage />} />
        <Route path="configurations/service-types" element={<ServiceTypesPage />} />
        <Route path="configurations/grades" element={<GradesPage />} />
        <Route path="configurations/part-codes" element={<PartCodesPage />} />
        <Route path="service-tracker" element={<ServiceTrackerPage />} />
        <Route path="service-tracker/:tab" element={<ServiceTrackerPage />} />
        <Route path="payment-desk/vendors" element={<Navigate to="/vendor-master" replace />} />
        <Route path="payment-desk" element={<PaymentDeskPage />} />
        <Route path="quote-master" element={<ComingSoonPage moduleKey="quote-master" />} />
        <Route path="procure-flow" element={<ComingSoonPage moduleKey="procure-flow" />} />
        <Route path="daily-log-check" element={<DailyLogCheckPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
